module.exports = __webpack_public_path__ + "media/img/corporate/logos/ubs-acfd691c909b4e5ef46b895506369be9.svg";